import { API } from '~/constants';
import { PersonaLabel } from '~/interfaces';
import { get, getApi, getOdmId, isNumber, post } from '~/utils';

const getSuiteId = (suiteId?: number) => {
    if (isNumber(suiteId)) {
        return suiteId;
    }
    if (isNumber(window.platform_suite_id)) {
        return window.platform_suite_id;
    }
    return undefined;
};

export const fetchPersonaLabel = (suiteId?: number) => {
    return post<PersonaLabel>(getApi(API.conf.get_persona_label), {
        suite_id: getSuiteId(suiteId),
        odm_id: getOdmId()
    });
};

export const updatePersonaInfo = ({
    data,
    tenantId,
    suiteId
}: {
    data: Record<string, any>;
    tenantId?: string;
    suiteId?: number;
}) => {
    const payload = { ...data };
    return post(
        getApi(API.conf.update_register_info, tenantId || get(window, 'jdy_tenant_info.id')),
        { ...payload, suite_id: getSuiteId(suiteId) }
    );
};
